var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PepType, EntityType, PepStatus } from "../pages/PepContext";
import { DateTime } from "luxon";
export function stateToRequest(pepState) {
    const state = Object.assign({}, pepState);
    delete state.isLocalCountry;
    delete state.isOngoing;
    delete state.ownerName;
    if (state.legalEntityType === EntityType.PERSON) {
        delete state.tin;
    }
    return Object.assign(Object.assign({}, state), { country: state.type === PepType.NOT_PEP ? undefined : state.country, ended: state.ended
            ? DateTime.fromJSDate(state.ended).toFormat("yyyy-MM")
            : undefined, birthdayOfPEP: state.birthdayOfPEP
            ? DateTime.fromJSDate(state.birthdayOfPEP).toFormat("yyyy-MM-dd")
            : undefined });
}
export function requestToState(_a, countryCode) {
    var { ended, birthdayOfPEP } = _a, serverData = __rest(_a, ["ended", "birthdayOfPEP"]);
    const state = Object.assign({}, serverData);
    if (ended) {
        state.ended = DateTime.fromFormat(ended, "yyyy-MM").toJSDate();
    }
    if (birthdayOfPEP) {
        state.birthdayOfPEP = DateTime.fromFormat(birthdayOfPEP, "yyyy-MM-dd").toJSDate();
    }
    state.isLocalCountry = state.country === countryCode ? "local" : "other";
    state.isOngoing = state.ended ? PepStatus.ENDED : PepStatus.ONGOING;
    return state;
}
